export default __webpack_public_path__ + "static/media/bids-1.83c97350.jpg";